<div class="public-container" id="home" style="max-width:100vw; max-height:100vh; position:fixed; top:0; left:0; z-index:-1;"><JMCarousel></JMCarousel></div>